import { ActionEnum } from '../../definitions/enums/ActionEnum';
import { ActionType } from '../../definitions/types/ActionType';
import { StateType } from '../../definitions/types/StateType';
import { addReducer } from './addReducer';
import { parseReducer } from './parseReducer';
import { removeReducer } from './removeReducer';
import { selectReducer } from './selectReducer';
import { updateTabReducer } from './updateTabReducer';

export function workspaceActionReducer(
  state: StateType,
  action: ActionType,
): StateType {
  switch (action.type) {
    case ActionEnum.add: {
      return addReducer(state, action);
    }
    case ActionEnum.parse: {
      return parseReducer(state, action);
    }
    case ActionEnum.remove: {
      return removeReducer(state, action);
    }
    case ActionEnum.select: {
      return selectReducer(state, action);
    }
    case ActionEnum.updateTab: {
      return updateTabReducer(state, action);
    }
    default: {
      throw new Error('Unhandled action type');
    }
  }
}
